<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="downloads mx-auto py-3">
          <div>
            <h2 class="text-secondary mb-4"
                v-b-toggle.collapse-downloads-section>
              <span>
                {{content.custom_section_name ? content.custom_section_name : 'DOWNLOADS'}}
              </span>
              <span>
                <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
              </span>
            </h2>
            <b-collapse visible id="collapse-downloads-section">
              <div v-for="(item, index) in content.files" :key="`downloads-item-${index}`"
                  class="downloads-item mx-auto mb-3">
                <a :href="item.file" target="_blank">
                  <img src="@/assets/icons/download.svg" class="img-fluid mr-3">
                  <span class="bold">{{item.title}}</span>
                </a>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
h2 {
  font-size: 25px;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:focus {
    outline: 0;
  }
  img {
    width: 15px;
  }
  img.when-open {
    transform: rotate(-90deg);
  }
  &.collapsed img.when-open,
  &.not-collapsed img.when-closed {
    display: none;
  }
}
.downloads-item {
  max-width: 90%;
  a {
    display: flex;
    align-items: center;
  }
  img {
    max-width: 30px;
  }
}
</style>
